module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_combo_duo_cuadrada_motivo_2.75898b0b.png";